<template>
  <div 
    style="
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;
        background: #fff;"
    >
    <div ref="canvasRef" id="canvasRef" width="1000" height="1000"></div>
  </div>
</template>

<script>
import Konva from 'konva'
import { loadFont } from '../../helper/helper'
import { CDN_URL } from '../../config';
export default {
  name: 'CrossswordCanvas',
  props: {
    bodyRender: {
      type: Object,
      default() {
        return {}
      }
    },
    fontFamily: {
      type: String,
      default() {
        return ''
      }
    }
  },
  emits: ['change'],
  data() {
    return {
      isCanvas: null
    }
  },
  watch: {
    bodyRender(value) {
      this.renderImage(value)
    }
  },
  mounted() {
    const { fontFamily } = this
    if (fontFamily && fontFamily != '') {
      loadFont(fontFamily)
    }
    this.isCanvas = this.$refs.canvasRef
  },
  methods: {
    removeVietnameseTones: str => {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
      str = str.replace(/đ/g, 'd')

      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
      str = str.replace(/Đ/g, 'D')

      // Some additional characters
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '') // Combining accents
      str = str.replace(/\u02C6|\u0306|\u031B/g, '') // Other diacritics

      return str
    },
    getCharGrid(tags) {
      const words = tags.map(e => {
        return {
          clue: '',
          answer: this.removeVietnameseTones(e).toUpperCase()
        }
      })
      const crossword = generateLayout(words)

      let charGrid = crossword.table
      charGrid = charGrid.map(innerArray =>
        innerArray.map(item => (item === '-' ? '' : item))
      )
      return charGrid
    },
    loadImage(url) {
      if(url.indexOf('cloudfront.net') >= 0){
        const splitUrl = url.split('cloudfront.net');
        const key = splitUrl[1];
        url = CDN_URL + '/auto' + key;
      }
      return new Promise((resolve, reject) => {
        var imageObj = new Image()
        imageObj.crossOrigin = 'anonymous'
        imageObj.onload = function() {
          resolve(imageObj); // Trả về đối tượng hình ảnh khi đã tải xong
        }
        imageObj.onerror = function() {
          reject(new Error('Failed to load image at ' + url)) // Trả về lỗi nếu việc tải hình ảnh thất bại
        }
        imageObj.src = url
      })
    },
    configGroup({ columnIndex, rowIndex, tileSize, padding, scale }) {
      const configs = {
        x: columnIndex * (tileSize + padding) + (padding + padding / 2),
        y: rowIndex * (tileSize + padding) + (padding + padding / 2)
      }
      ;['x', 'y'].forEach(t => {
        if (configs[t]) {
          configs[t] = configs[t] * scale
        }
      })
      return configs
    },
    configRect: ({
      tileSize,
      background,
      shadowColor = 'rgba(0, 0, 0, 0.5)',
      shadowBlur = 2,
      shadowOffsetX = 0,
      shadowOffsetY = 0,
      shadowOpacity = 1,
      borderColor = '#ac5d1d',
      borderWidth = 2,
      borderRadius = 5,
      scale
    }) => {
      const configs = {
        width: tileSize,
        height: tileSize,
        fillPatternImage: background,
        fillPatternScale: {
          x: (tileSize / background.width) * scale,
          y: (tileSize / background.height) * scale
        },
        shadowColor,
        shadowBlur,
        shadowOffsetX,
        shadowOffsetY,
        shadowOpacity,
        stroke: borderColor,
        strokeWidth: borderWidth,
        cornerRadius: borderRadius
      }

      ;[
        'width',
        'height',
        'shadowBlur',
        'shadowOffsetX',
        'shadowOffsetY',
        'strokeWidth',
        'cornerRadius'
      ].forEach(t => {
        if (configs[t]) {
          configs[t] = configs[t] * scale
        }
      })
      return configs
    },
    getLetterPoints(letter) {
      const letterPoints = {
        A: 1,
        B: 3,
        C: 3,
        D: 2,
        E: 1,
        F: 4,
        G: 2,
        H: 4,
        I: 1,
        J: 8,
        K: 5,
        L: 1,
        M: 3,
        N: 1,
        O: 1,
        P: 3,
        Q: 10,
        R: 1,
        S: 1,
        T: 1,
        U: 1,
        V: 4,
        W: 4,
        X: 8,
        Y: 4,
        Z: 10
      }
      const upperLetter = letter.toUpperCase()
      return letterPoints[upperLetter] || 0
    },
    configsPointsText({
      char,
      letterPointsFontSize = 15,
      letterPointsFontFamily,
      textColor = '#000000',
      tileSize,
      scale,
      customMarginLeftPointText,
      customMarginTopPointText
    }) {
      const points = this.getLetterPoints(char)
      const configs = {
        text: points.toString(),
        fontSize: letterPointsFontSize,
        fontFamily: letterPointsFontFamily,
        fill: textColor,
        x: -10 + customMarginLeftPointText,
        y: -10 + customMarginTopPointText,
        width: tileSize,
        height: tileSize,
        verticalAlign: 'bottom',
        align: 'right'
      }
      ;['fontSize', 'x', 'y', 'width', 'height'].forEach(t => {
        if (configs[t]) {
          configs[t] = configs[t] * scale
        }
      })
      return configs
    },
    configsText: ({
      char,
      fontSize = 60,
      textColor = '#000000',
      tileSize,
      fontFamily,
      textOpacity = 1,
      scale,
      customMarginLeftText,
      customMarginTopText
    }) => {
      const configs = {
        text: char,
        fontSize,
        fontStyle: 'bold',
        fill: textColor,
        width: tileSize,
        height: tileSize,
        align: 'center',
        x: 0 + customMarginLeftText,
        y: 0 + customMarginTopText,
        verticalAlign: 'middle',
        fontFamily: fontFamily,
        opacity: textOpacity,
        lineHeight: 0
      };
      ['fontSize', 'x', 'y', 'width', 'height'].forEach(t => {
        if (configs[t]) {
          configs[t] = configs[t] * scale
        }
      })
      return configs
    },
    async renderImage(values) {
      const { isCanvas } = this
      const THIS = this
      const {
        tags,
        backgroundImage,
        backgroundScrabbleImages,
        borderColor,
        borderRadius,
        borderWidth,
        fontFamily,
        fontSize,
        width,
        height,
        letterPointsEnabled,
        letterPointsFontFamily,
        letterPointsFontSize,
        margin,
        maxLength,
        shadowBlur,
        shadowColor,
        shadowOffsetX,
        shadowOffsetY,
        shadowOpacity,
        textColor,
        textOpacity,
        titleBackground,
        customMarginLeftText = 0,
        customMarginTopText = 0,
        customMarginLeftPointText = 0,
        customMarginTopPointText = 0,
        type
      } = values;

      const tileSize = 100
      const padding = margin
      let charGrid = this.getCharGrid(tags)

      const rows = charGrid.length
      const columns = charGrid[0].length

      const contentWidth = columns * (tileSize + padding) + padding * 2
      const contentHeight = rows * (tileSize + padding) + padding * 2

      const iWidth = 1000
      const iScale = iWidth / width

      const widthCanvas = width * iScale
      const heightCanvas = height * iScale

      const scaleX = widthCanvas / contentWidth
      const scaleY = heightCanvas / contentHeight
      const scale = Math.min(scaleX, scaleY)

      const offsetX = (widthCanvas - contentWidth * scale) / 2
      const offsetY = (heightCanvas - contentHeight * scale) / 2

      const stage = new Konva.Stage({
        container: "canvasRef",
        width: widthCanvas,
        height: heightCanvas
      })
      const layer = new Konva.Layer({
        x: offsetX,
        y: offsetY,
        width: contentWidth * scale,
        height: contentHeight * scale
      })
      stage.add(layer);
      let background = await this.loadImage(
        backgroundImage
          ? backgroundImage
          : 'https://d111oohu250q1p.cloudfront.net/upload-custom/1uJC3iehJ9HA6pfCKjWm67.png'
      )

      charGrid.forEach((row, rowIndex) => {
        row.forEach((char, columnIndex) => {
          if (char) {
            // Create a group for each tile to combine background and text
            const group = new Konva.Group(
              THIS.configGroup({
                columnIndex,
                rowIndex,
                padding,
                scale,
                tileSize
              })
            )

            // Add tile background
            const tile = new Konva.Rect(
              THIS.configRect({
                tileSize,
                background,
                shadowColor,
                shadowBlur,
                shadowOffsetX,
                shadowOffsetY,
                shadowOpacity,
                borderColor,
                borderWidth,
                borderRadius,
                scale
              })
            )
            group.add(tile)

            // Add text to tile
            const text = new Konva.Text(
              THIS.configsText({
                char,
                fontFamily,
                fontSize,
                scale,
                textColor,
                textOpacity,
                tileSize,
                customMarginLeftText,
                customMarginTopText
              })
            )
            group.add(text)

            if (letterPointsEnabled) {
              const pointsText = new Konva.Text(
                this.configsPointsText({
                  char,
                  letterPointsFontFamily,
                  letterPointsFontSize,
                  scale,
                  textColor,
                  tileSize,
                  customMarginLeftPointText,
                  customMarginTopPointText
                })
              )
              group.add(pointsText)
            }
            layer.add(group)
          }
        })
      })
      layer.draw()
      const canvas = stage.toCanvas()
      const base64 = canvas.toDataURL()
      this.$emit('change', {
        base64,
        backgroundImage,
        tags,
        type
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Render/CrossswordCanvas.vue